<template>
  <div class="field">
    <div class="field-name">{{ field.label }}</div>
    <input v-model="field.value" type="color" />
  </div>
</template>

<script>
import { EMITTERS } from '../../shared/utils/emitters'

export default {
  name: 'ColorPicker',
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:value', 'change'],
  data() {
    return {
      EMITTERS,
    }
  },
  watch: {
    'field.value'() {
      this.emitValueUpdate()
    },
  },
  methods: {
    emitValueUpdate() {
      this.$emit('change', this.field)
      this.$emit('update:value', this.field)
    },
  },
}
</script>

<style scoped lang="scss">
.field {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
  .field-name {
    width: 150px;
    text-align: right;
    margin-right: 10px;
  }
  input,
  textarea {
    max-width: 250px;
  }
}
</style>
